"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeEntity = exports.encodeEntity = void 0;
const XmlEntities = require('html-entities/lib/xml-entities');
const xmlEntities = new XmlEntities();
const encodeEntity = (text) => xmlEntities.encode(text);
exports.encodeEntity = encodeEntity;
const decodeEntity = (text) => xmlEntities.decode(text);
exports.decodeEntity = decodeEntity;
